export default __webpack_public_path__ + "static/firesmoke-667f69bdacead9c9846451918639fe44.png";